import {Component, input} from '@angular/core';

/**
 * CSS grid list that replaces the tables. Set the columns once on the list, the rows inherit them:
 * `<app-data-list columns="110px minmax(0,1fr) 16px">` with `app-data-row`s inside.
 * `minWidth` keeps the columns readable on small screens; the list then scrolls horizontally.
 */
@Component({
    selector: 'app-data-list',
    templateUrl: './data-list.component.html',
    styles: `
        :host {
            display: block;
            overflow-x: auto;
        }
    `,
    host: {
        'role': 'table',
        '[style.--ui-cols]': 'columns()',
        '[style.--ui-row-min-width]': 'minWidth()',
        '[style.--ui-row-gap]': 'gap()'
    }
})
export class DataListComponent {
    readonly columns = input.required<string>();
    readonly minWidth = input<string>('0');
    readonly gap = input<string>('16px');
}
